import { render, staticRenderFns } from "./CalendarsPage.vue?vue&type=template&id=b75f5f72&scoped=true"
import script from "./CalendarsPage.vue?vue&type=script&lang=js"
export * from "./CalendarsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b75f5f72",
  null
  
)

export default component.exports